import React, { useState } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import KenLoader from "../../GlobalComponents/KenLoader";

import AdminLayout from "../../Components/Layout/AdminLayout";
import AuctionLayout from "../../Components/Layout/AuctionLayout";
import {
  PrivateRoute,
  PublicRoute,
  TeamPrivateRoute,
} from "../../Utils/helperFunctions";
import routes from "../../Utils/routes";
import IconPlayers from "../Auction/IconPlayers";
import TeamDetails from "../Auction/TeamDetails";
import Login from "../Auth/Login";
import Dashboard from "../Dashboard";
import SquadList from "../SquadList";
import TeamsDashboard from "../TeamsDashboard";
import AdminTeamDetails from "../AdminTeamDetails";
// import ContactSuccess from "../Auth/ContactSuccess";

// home
const PlayerAuctionScreen = React.lazy(() => import("../Auction/Sold"));
const PlayerStats = React.lazy(() => import("../Auction/PlayerStats"));

//Not Found

const RootRedirect = () => {
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  const isTeamAuthenticated =
    localStorage.getItem("isTeamAuthenticated") === "true";

  if (isAuthenticated) {
    return <Navigate to={routes.dashboard} replace />;
  }

  if (isTeamAuthenticated) {
    return <Navigate to={routes.teamDashboard} replace />;
  }

  return <Navigate to={routes.login} replace />;
};

const MainLayout: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  return loading ? (
    <KenLoader />
  ) : (
    <>
      <Routes>
        {/* Initial Route */}
        <Route path="/" element={<RootRedirect />} />
        <Route
          path={routes.login}
          index
          element={
            // <PublicRoute userType="general">
              <Login />
            // </PublicRoute>
          }
        />

        <Route
          path={routes.teamLogin}
          index
          element={
            // <PublicRoute userType="team">
              <Login />
            // </PublicRoute>
          }
        />

        <Route
          path={routes.dashboard}
          element={
            <PrivateRoute>
              <AdminLayout>
                <Dashboard />
              </AdminLayout>
            </PrivateRoute>
          }
        />
 

        <Route
          path={routes.adminTeamDetails}
          element={
            <AdminLayout>
              <AdminTeamDetails />
            </AdminLayout>
          }
        />

        {/* Auction Screens */}

        <Route
          path={routes.teamDetails}
          index
          element={
            // <PrivateRoute>
            <AuctionLayout>
              <TeamDetails />
            </AuctionLayout>
            // </PrivateRoute>
          }
        />
        <Route
          path={routes.iconPlayers}
          index
          element={
            // <PrivateRoute>
            <AuctionLayout>
              <IconPlayers />
            </AuctionLayout>
            // </PrivateRoute>
          }
        />
        <Route
          path={routes.squadList}
          index
          element={
            // <PrivateRoute>
            <AuctionLayout>
              <SquadList />
            </AuctionLayout>
            // </PrivateRoute>
          }
        />
        <Route
          path={routes.playerAuction}
          index
          element={
            // <PrivateRoute>
            <AuctionLayout>
              <PlayerAuctionScreen />
            </AuctionLayout>
            // </PrivateRoute>
          }
        />

        <Route
          path={routes.playerStats}
          index
          element={
            // <PrivateRoute>
            <AuctionLayout>
              <PlayerStats />
            </AuctionLayout>
            // </PrivateRoute>
          }
        />

        <Route
          path={routes.teamDashboard}
          index
          element={
            <TeamPrivateRoute>
              <TeamsDashboard />
            </TeamPrivateRoute>
          }
        />
      </Routes>
    </>
  );
};

export default MainLayout;
